module.exports = __webpack_public_path__ + "static/progetto_valtellinapalace4_dettaglio-ce61dc8b43f5eb314a1366242abf9bc1.jpg";